import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card'; // Assuming you have these components

const ordersList = () => {
  return (
    <div className="p-6 space-y-6">
      {/* Cards */}
      <div className="grid gap-6 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
        <Card className="shadow-lg p-1 border rounded-xl">
          <CardHeader>
            <CardTitle>Total Orders</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-3xl font-bold text-blue-600">500</p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default ordersList;

